<template>
  <audio autoPlay ref="audioEl"/>
</template>

<script>
export default {
  props: ["track"],
  name: "AudioTrack",
  mounted() {
    this.$refs.audioEl.srcObject = new MediaStream([this.track])
  }
}
</script>

<style scoped>

</style>